import { chunk, orderBy } from 'lodash';
import React, { useContext } from 'react';
import { LeaderboardContext } from '../context';

// import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import {
  InnerGrid,
  OuterGrid,
  EntriesBox,
  EntriesPageWrapper,
  QuestionCell,
  EntriesWrapper,
  NameCell,
  Title,
  RankTitle,
  ScoreTitle,
  RankCell,
  ScoreCell,
} from '../styles';

import Header from '../components/entries/header';
import EntriesList from '../components/entries/list';

function Entries({ offset, userEntries, questions, timer }) {
  const { attributes: leaderboard } = useContext(LeaderboardContext);

  const page = timer - offset;
  const questionKeys = Object.keys(questions);
  const columns = questionKeys.length;

  const chunkedUserEntries = chunk(
    leaderboard.sorted
      ? orderBy(userEntries, 'rank', 'asc')
      : orderBy(userEntries, 'score', 'desc'),
    'display' in leaderboard && leaderboard.display === 'monitor' ? 10 : 9
  );

  const activeUserEntries = chunkedUserEntries[page];

  return (
    <EntriesPageWrapper withParent={false}>
      <Header />

      <EntriesBox>
        <OuterGrid scored={!leaderboard.sorted} header>
          <NameCell header>
            <Title textAlign="left">Name</Title>
          </NameCell>

          <InnerGrid columns={columns} scored={!leaderboard.sorted} header>
            {Object.keys(questions).map(key => (
              <QuestionCell
                key={`question-title-${key}`}
                scored={!leaderboard.sorted}
                header
              >
                <Title>{questions[key].name}</Title>
              </QuestionCell>
            ))}
          </InnerGrid>

          {leaderboard.sorted ? null : (
            <ScoreCell header>
              <ScoreTitle>Current Points</ScoreTitle>
            </ScoreCell>
          )}

          <RankCell header sorted={leaderboard.sorted}>
            <RankTitle>Rank</RankTitle>
          </RankCell>
        </OuterGrid>

        <EntriesWrapper>
          <EntriesListWrapper key={`entries-list-${page}`}>
            <EntriesList
              columns={columns}
              userEntries={activeUserEntries}
              questions={questions}
            />
          </EntriesListWrapper>
        </EntriesWrapper>
      </EntriesBox>
    </EntriesPageWrapper>
  );
}

const EntriesListWrapper = styled(motion.div)`
  label: entries-list-wrapper;

  width: 100%;
`;

export default Entries;
